import React from 'react';

import DashboardView from '../../views/dashboard/DashboardView.js';
import SuccessView from '../../views/dashboard/SuccessView.js';
import * as Auth from '../../services/Auth.Service.js';
import * as Services from '../../services/Dashboard.Service.js';
import WriteReviewModal from '../../views/items/modal/WriteReviewModal.js';
import * as Items from '../../services/Items.Service.js';
import $ from 'jquery';

var typingTimer;
export class DashboardComponent extends React.Component {

	/**
	 * Class constructor.
	 * @argument {object} props
	 */
	constructor(props) {
		super(props);

		var url_string = window.location.href; //window.location.href
		var url = new URL(url_string);
		var item_id = url.searchParams.get("faver_id");

		this.state = {
			limit: 20,
			search_key: "",
			continue_scroll: true,
			results: [],
			selected_faver: false,
			success: false,
			search_input: null,
			os: '',
			faver_id: item_id,
			faver_data: {},
			contacts: [],
			faver: {
				faver_id: '',
				item_id: '',
				comment: '',
				contact_id: '',
				name: '',
			},
			user: {},
			new_contact: {
				first_name: '',
				last_name: '',
				phone: ''
			},
			error: false,
			isLoading: false,
			show_write_review_modal: false,
			full_name: '',
			customMessage: false,
			btn_disable: true,
			webSearchActive: false,
			searchingInWeb: false,
			resultsWeb: [],
			selected_optionWeb: false,
			creating_item: false,
			failIframe:false,
			webSearchTerm: 'g',
			emptyFaverResults: false,
			item: {},
		};
		this.SearchTerm = this.SearchTerm.bind(this);
		this.SelectFaver = this.SelectFaver.bind(this);
		this.RequestFaver = this.RequestFaver.bind(this);
		this.selectContact = this.selectContact.bind(this);
		this.changeComment = this.changeComment.bind(this);
		this.sendFaver = this.sendFaver.bind(this);
		this.changeNewContact = this.changeNewContact.bind(this);
		this.replaceImage = this.replaceImage.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.changeFaver = this.changeFaver.bind(this);
		this.changeFullName = this.changeFullName.bind(this);
		this.toggleWriteReviewModal = this.toggleWriteReviewModal.bind(this);
		this.getSearch = this.getSearch.bind(this);
		this.search = this.search.bind(this);
		this.webSearch = this.webSearch.bind(this);
		this.selectNewFaver = this.selectNewFaver.bind(this);
		this.useThisPage = this.useThisPage.bind(this)
		this.returnViewDefault = this.returnViewDefault.bind(this);
		this.openContentWindow = this.openContentWindow.bind(this);
		this.getItem = this.getItem.bind(this);
	}

	componentWillMount() {
		this.RequestFaver();
		// Opera 8.0+
		var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

		// Firefox 1.0+
		var isFirefox = typeof InstallTrigger !== 'undefined';

		// Safari 3.0+ "[object HTMLElementConstructor]" 
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

		// Internet Explorer 6-11
		var isIE = /*@cc_on!@*/false || !!document.documentMode;

		// Edge 20+
		var isEdge = !isIE && !!window.StyleMedia;

		// Chrome 1 - 71
		var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

		// Blink engine detection
		var isBlink = (isChrome || isOpera) && !!window.CSS;


		var os = '';
		var output = 'isFirefox: ' + isFirefox + '<br>';
		output += 'isChrome: ' + isChrome + '<br>';
		output += 'isSafari: ' + isSafari + '<br>';
		output += 'isOpera: ' + isOpera + '<br>';
		output += 'isIE: ' + isIE + '<br>';
		output += 'isEdge: ' + isEdge + '<br>';
		output += 'isBlink: ' + isBlink + '<br>';
		if (isSafari) {
			os = 'ios'
		}
		else {
			os = 'android'
		}
		this.setState(
			{
				os: output
			}
		)
	}

	RequestFaver() {
		var id = this.state.faver_id;

		Services.Request(id)
			.onSuccess(
				function (data) {
					var faver = this.state.faver;
					faver.faver_id = data.id;
					if (data.contacts.length > 0) {
						faver.contact_id = data.contacts[0].id;
					}
					else {
						delete data.contact_id;
					}

					if (data.user_id.image_url != null && data.user_id.image_url != "") {
						data.user_id.user_img_url = "url('" + data.user_id.image_url + "')";
					} else {
						data.user_id.user_img_url = "url(/assets/img/default.png)";
					}
					//Icon
					data.category_id.icon = this.GetCategoryIcon(data.category_id.name);
					this.setState(
						{
							faver_data: data,
							contacts: data.contacts,
							user: data.user_id,
							faver: faver
						}
					)

				}.bind(this)
			)
			.onError(
				function (xhr) {

				}.bind(this)
			)
			.onComplete(
				function () {

				}
			);
	}	

	//Search term
	SearchTerm(event) {
		const search_key = event.target.value;
		if (search_key.length >= 1) {

			//Clear callback if defined
			if (this.state.typingCallback) {
				clearTimeout(this.state.typingCallback);
			}

			let context = this;
			let typingCallback = setTimeout(function () {
				//Perfom call
				context.setState({
					search_key,
					continue_scroll: true,
					search_input: event.target,
					results: [],
				}, () => {
					//Get content
					context.search("search");
				});
			}, 1000);
			this.setState({
				typingCallback
			});
		}
	}

	// Handle search scroll
	handleScroll(e) {
		const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;		
		if (bottom && this.state.continue_scroll) {
			this.search("scroll");
		}
	}

	//Change faver
	changeFaver() {
		this.state.search_input = null;
		this.setState({
			search_key: '',
			continue_scroll: true,
			results: [],
			selected_faver: false,
		});
	}

	//Search method
	search(type_search) {
		let results = (type_search == "search") ? [] : this.state.results;
		this.setState(
			{
				isLoading: true,
				btn_disable: true,
				emptyFaverResults: false,
			}, () => {
			//function () {				
				const category_id = this.state.faver_data.category_id.id;
				const genre_id = this.state.faver_data.genre_id && this.state.faver_data.genre_id.id ? this.state.faver_data.genre_id.id : null;			
				const offset = this.state.results.length;				
				Services.Search(this.state.search_key, category_id, genre_id, this.state.limit, offset)
					.onSuccess(
						function (data) {
							//State variables
							const state = {
								isLoading: false,
								results: results.concat(data.items),
								btn_disable: false,
							}
							//If the number of results is lower it means it should stop scrolling
							if (data.items.length < this.state.limit) {
								state.continue_scroll = false;
								state.btn_disable = true;
							}else{
								state.continue_scroll = true;
							}
							//Check that there is at least one result if not search in web
							if(state.results.length == 0){
								let search_key = this.state.search_key;
								this.webSearch(false, true, search_key);
								state.emptyFaverResults = true;
							}

							//Set state
							this.setState(state)

						}.bind(this)
					)
					.onError(
						function (xhr) {
							this.setState(
								{
									isLoading: false,
									btn_disable: false
								}
							)
						}.bind(this)
					)
					.onComplete(
						function () {

						}
					);
			});
			//}.bind(this), 1000);
	}

	GetCategoryIcon(name) {
		let icon = '/assets/img/svgs/custom.svg';
		switch (name) {
			case "Movies":
				icon = '/assets/img/svgs/movies.svg';
				break;
			case "Music":
				icon = '/assets/img/svgs/music.svg';
				break;
			case "Books":
				icon = '/assets/img/svgs/books.svg';
				break;
			case "Video Games":
				icon = '/assets/img/svgs/Video Games.svg';
				break;
			//case "TV Series":
			case "TV Shows":
				//icon = '/assets/img/svgs/TV Series.svg';
				icon = '/assets/img/svgs/TV.svg';
				break;
		}
		return icon;
	}

	SelectFaver(item) {
		var faver = this.state.faver;
		faver.item_id = item.id;
		this.setState({
			selected_faver: item,
			faver: faver
		})
	}

	selectContact(event) {
		var faver = this.state.faver;
		faver.contact_id = event.target.value;
		this.setState(
			{
				faver
			}
		)
	}

	changeComment(event) {
		var faver = this.state.faver;
		faver.comment = event.target.value;
		this.setState(
			{
				faver
			}
		)
	}

	changeFullName(event){
		//Set full name
		const full_name = event.target.value.trim();
		var faver = this.state.faver;
		faver.name = event.target.value;
		//Set state
		this.setState({
			full_name,
			faver,
		});
	}

	changeNewContact(event) {
		var new_contact = this.state.new_contact;
		var field = event.target.id;
		if (field == 'phone') {
			new_contact[field] = this.filterPhoneNumber(event);
		}
		else {
			new_contact[field] = event.target.value;
		}

		this.setState(
			{
				new_contact
			}
		)
	}
	/**
 * Filter phone number
 *
 * @param {object} element - the JS event object
 */
	filterPhoneNumber(element) {

		let mask = "+***********";

		let mask_value = function (value, mask, mask_char) {
			let k = mask_char == undefined ? '*' : mask_char,
				o = '',
				v = value;
			for (let i = 0; v.length > 0 && i < mask.length; i++) {
				if (mask[i] == k) {
					o += v[0];
					v = v.slice(1, v.length);
				} else {
					o += mask[i];
				}
			}

			return o;
		};
		//Gets the range of selected text for target
		let selection = function (element) {
			if (!('selectionStart' in element.target)) {
				return undefined;
			}

			return [element.selectionStart, element.selectionEnd];
		};
		/*
		 If there was no range then just forget about it because browser support is not
		 present and this wont work.
		 */
		if (selection == undefined)
			return;
		//Current caret position
		let pos = selection[0];
		//Value in the text box
		let val = element.target.value;
		//Gets the segment before the cursor
		let before = val.slice(0, pos);
		//Removes all non numeric chars from the before segment
		let stripBefore = before.replace(/\D/g, '');
		//Adjusts the caret position based off the removed non numeric chars.
		let stripPos = pos - (before.length - stripBefore.length);
		//Applies the mask the the stripped before segment
		let maskBefore = mask_value(stripBefore, mask);
		//Adjust the caret position based on the chars added to the before segment.
		let maskPos = stripPos - (stripBefore.length - maskBefore.length);
		//Replaces the value with a masked version of the value
		let new_val = mask_value(val.replace(/\D/g, ''), mask);
		return new_val;
		//Repositions the caret.
		//e.target.setSelectionRange(maskPos, maskPos);
	}
	sendFaver() {
		let faver = this.state.faver;
		//Validation
		//if(faver.comment == ""){
		if(faver.name == ""){
			const error = {
				//message: "Add a Message is required",
				message: "Please enter you name in the From field",
				code: 0,
			};
			this.setState({
				error
			});
			return;
		}
		//User name
		if (!faver.contac_id) {
			//Set name
			//A user name is required by the API this avoids having to mod the workflow
			if(!this.state.full_name){
				faver.first_name = "Anonymous";
				faver._last_name = "User";
			}else{
				faver.first_name = this.state.full_name;
			}
			faver.phone = "";
		}
		Services.SendFaver(faver)
			.onSuccess(
				function (data) {
					let pos = data.url.indexOf('/item/');
					let id_item = data.url.slice(pos + 6);
					this.getItem(id_item);
					this.setState(
						{
							success: true
						}
					)

				}.bind(this)
			)
			.onError(
				function (xhr) {
					const error = {};

					error.message = xhr.responseJSON.error.message;
					error.code = xhr.responseJSON.error.code;
					this.setState({
						error
					});
				}.bind(this)
			)
			.onComplete(
				function () {

				}
			);
	}

	replaceImage(image) {
		image.target.onerror = "";
		image.target.src = "/assets/img/icons/placeholderAlbum.png";
		return true;
	}

	toggleWriteReviewModal(status, message) {
		let webSearchActive = this.state.webSearchActive;
		let emptyFaverResults = this.state.emptyFaverResults;
		if (webSearchActive || emptyFaverResults) {
			this.setState({
				show_write_review_modal: status,
				customMessage: message
			});
		} else {
			
			this.setState({
				results: [],
				webSearchActive: true,
				selected_faver: false,
				search_key: "",
			});
			let search_key = this.state.search_key;
			this.webSearch(false, true, search_key)
			
		}
	}

	getSearch(){
		this.search("scroll");
	}

	webSearch(event, directSearch, directSearchTerm) {
		let type_search = event ? event.target.value: directSearchTerm;
		let isLoading= true;
		if (event && event.key != 'Enter') {
			this.setState({
				webSearchTerm : type_search
				});
			return;
		}
		if(directSearch){			
			setTimeout(
				function () {
					$('.input-form').val(type_search);
				}.bind(this),
				800
			  );			
		}
		this.setState(
			{
				isLoading,
				btn_disable: true,
				searchingInWeb: true,
			});
		Services.WebSearch(type_search)
			.onSuccess(
				function (data) {
					for(let item of data){
						let img_base = item.pagemap.cse_image ? item.pagemap.cse_image[0].src : '/assets/img/icons/placeholderAlbum.png';
						let imageExists = (item.pagemap.cse_image && item.pagemap.cse_image[0].src);
						let descrition = (item.pagemap.metatags && item.pagemap.metatags[0]['og:description']) ? item.pagemap.metatags[0]['og:description'] :
							(item.pagemap.metatags && item.pagemap.metatags[0]['twitter:description']) ? item.pagemap.metatags[0]['twitter:description'] :
								item.snippet;
						//clean URL img
						const arrar_formats = ['.jpg', '.png', '.jpeg']
						for (let item of arrar_formats) {
							let indexOfFirst = img_base.indexOf(item);
							if (indexOfFirst != -1) {
								img_base = img_base.slice(0, indexOfFirst + 4);
								break;
							}
						}
						item.img_preview = img_base;
						item.description = descrition;
						item.imageExists = imageExists;
					}
					this.setState({
							isLoading: false,
							resultsWeb: data,
							btn_disable: false,
						});
				}.bind(this)
			)
			.onError(
				function (xhr) {
					const error = {};
					error.message = xhr.responseJSON.error.message;
					error.code = xhr.responseJSON.error.code;
					this.setState({
						error,
						isLoading: false,
						btn_disable: false,
					});
				}.bind(this)
			)
			.onComplete(
				function () {
				}
			);
	}

	selectNewFaver(item) {
		if (!item) {
			this.setState({
				selected_optionWeb: false,
				isLoading: false,
				creating_item: false,
				failIframe:false
			})
			return
		}
		this.setState({
			selected_optionWeb: item,
		})
	}

  useThisPage() {
    this.setState({
      creating_item: true,
      error: false,
	  failIframe: false,
	  emptyFaverResults: false,
    });
    let selected_optionWeb = this.state.selected_optionWeb;
    let faver_data = this.state.faver_data;
    let category_id = faver_data.category_id.id;
    const data = {
      category_id: category_id,
      preview: 0,
      item_url: selected_optionWeb.link,
      name: selected_optionWeb.title,
      description: selected_optionWeb.htmlSnippet,
    }
	if (selected_optionWeb.imageExists) data.image = selected_optionWeb.img_preview;
    Services.CreateItemFromUr(data)
      .onSuccess(
        function (data) {
          this.SelectFaver(data);
          this.setState({
            creating_item: false,
            selected_optionWeb: false,
            webSearchActive: false,
            resultsWeb: [],
          });
        }.bind(this)
      )
      .onError(
        function (xhr) {
          const error = {};
          error.message = xhr.responseJSON.error.message;
          error.code = xhr.responseJSON.error.code;
          this.setState({
            error
          });
        }.bind(this)
      )
      .onComplete(
        function () {
        }
      );
  }

  returnViewDefault(value) {
    this.setState({
      webSearchActive: false,
      searchingInWeb: false,
    //resultsWeb: [],
      selected_optionWeb: false,
      creating_item: false,
    })
  }

	openContentWindow(url) {
		window.open(url);
	}

	getItem(id){
		Items.GetItem(id)
			.onSuccess(
				function (data) {
					let item = {};
					item.image = data.image_url ? data.image_url : null;
					this.setState({
						item: item,
					});						
				}.bind(this)
			)
			.onError(
				function (xhr) {
					const errors = {};
					errors.message = xhr.responseJSON.error.message;
					errors.code = xhr.responseJSON.error.code;				

					this.setState({
						errors
					});				
					
				}.bind(this)
			)
			.onComplete(
				function () {

				}.bind(this)
			);
	}

	/**
	 * Render the component.
	 */
	render() {
		return (
			<div>
				{
					!this.state.success ?
						<div>
							<DashboardView
								results={this.state.results}
								selected_faver={this.state.selected_faver}
								SearchTerm={this.SearchTerm}
								SelectFaver={this.SelectFaver}
								search_key={this.state.search_key}
								faver_data={this.state.faver_data}
								contacts={this.state.contacts}
								selectContact={this.selectContact}
								faver={this.state.faver}
								changeComment={this.changeComment}
								user={this.state.user}
								sendFaver={this.sendFaver}
								error={this.state.error}
								isLoading={this.state.isLoading}
								replaceImage={this.replaceImage}
								handleScroll={this.handleScroll}
								changeFaver={this.changeFaver}
								toggleWriteReviewModal = {this.toggleWriteReviewModal}
								full_name={this.state.full_name}
								changeFullName={this.changeFullName}
								getSearch={this.getSearch}
								continue_scroll={this.state.continue_scroll}
								search={this.search}
								btn_disable={this.state.btn_disable}
								webSearchActive={this.state.webSearchActive}
								webSearch={this.webSearch}
								searchingInWeb={this.state.searchingInWeb}
								resultsWeb={this.state.resultsWeb}
								selectNewFaver={this.selectNewFaver}
								selected_optionWeb={this.state.selected_optionWeb}
								useThisPage={this.useThisPage}
								creating_item={this.state.creating_item}
								returnViewDefault={this.returnViewDefault}
								myFunction={this.myFunction}
								failIframe={this.state.failIframe}
								openContentWindow={this.openContentWindow}
								webSearchTerm={this.state.webSearchTerm}
								emptyFaverResults={this.state.emptyFaverResults}
							/>
							<WriteReviewModal
								show_write_review_modal = {this.state.show_write_review_modal}
								customMessage = {this.state.customMessage}
								toggleWriteReviewModal = {this.toggleWriteReviewModal}
							/>
						</div>
						:
						<SuccessView
							os={this.state.os}
							openContentWindow={this.openContentWindow}
							item={this.state.item}
							user={this.state.user}
						/>
				}

			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/client/components/dashboard/DashboardComponent.js